import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-box_bottom_left_icon",
  "use": "icon-box_bottom_left_icon-usage",
  "viewBox": "0 0 29.95 30.02",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 29.95 30.02\" id=\"icon-box_bottom_left_icon\"><defs><style>#icon-box_bottom_left_icon .cls-1{fill:none;stroke:#7ce7fd;stroke-miterlimit:10;stroke-width:3px;}</style></defs><title>左下</title><g id=\"icon-box_bottom_left_icon_图层_2\" data-name=\"图层 2\"><g id=\"icon-box_bottom_left_icon_图层_1-2\" data-name=\"图层 1\"><path class=\"cls-1\" d=\"M30,28.51H11.5a10,10,0,0,1-10-10L1.53,0\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol